module.exports = __webpack_public_path__ + "static/img/icon_chuang.95c443f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon_chuang.png
// module id = mMLd
// module chunks = 1